import { z, toJSONSchema } from 'zod';
import Cookies from 'js-cookie';
import { TENANT_STORAGE_KEY } from '@constants/tenant';
import { CartService } from '@services/cart';
import { useServiceRef } from 'hooks/useServiceRef';
import { InputSchema, ToolDescriptor, ToolResponse } from '@mcp-b/webmcp-types';

export const getCartTool: ToolDescriptor<Record<string, unknown>, ToolResponse> = {
  name: 'get_cart',
  description: 'Get the current user\'s cart.',
  inputSchema: toJSONSchema(z.object({})) as InputSchema,
  execute: async (): Promise<ToolResponse> => {
    const cartServiceRef = useServiceRef(CartService);

    const tenantKey = JSON.parse(Cookies.get(TENANT_STORAGE_KEY)|| null)?.key;
    const cart = await cartServiceRef.current.getMyActiveCart(tenantKey);

    return {
      content: [ {
        type: 'text',
        text: `Found cart with ${cart?.lineItems?.length || 0} items and total price of ${cart?.totalPrice?.value || 0}. Cart: ${JSON.stringify(cart)}.`,
      } ]
    };
  }
};
